export const en = {
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About Us',
    contact: 'Contact',
    bookNow: 'Book Now',
  },
  hero: {
    tagline: 'Reliable & Detailed Cleaning',
    bookNow: 'Book Now',
    getQuote: 'Get a Quote',
  },
  services: {
    title: 'Our Services',
    subtitle: 'Professional cleaning tailored to your needs',
    house: {
      title: 'House Cleaning',
      desc: 'Comprehensive cleaning for your entire home, ensuring every corner shines.',
    },
    apartment: {
      title: 'Apartment Cleaning',
      desc: 'Efficient and thorough cleaning designed specifically for apartment living.',
    },
    office: {
      title: 'Office Cleaning',
      desc: 'Maintain a pristine and productive workspace with our reliable office cleaning.',
    },
    benefits: {
      title: 'Why Choose Us?',
      deep: 'Deep Cleaning',
      eco: 'Eco-friendly products',
      staff: 'Trained & Trusted staff',
      flexible: 'Flexible scheduling',
    },
    learnMore: 'Learn More',
  },
  about: {
    title: 'About Lucy Cleaning',
    storyTitle: 'Our Story',
    founderLabel: 'Founder',
    founderName: 'Lucy',
    story:
      'Founded with a passion for pristine spaces, Lucy Cleaning Services has been dedicated to bringing sparkle and comfort to homes and offices in Marshfield and beyond. We believe that a clean environment is the foundation of a happy, healthy life.',
    mission:
      'Our mission is to provide reliable, detailed, and trustworthy cleaning services that exceed expectations, allowing our clients to focus on what matters most to them.',
    values: {
      title: 'Our Core Values',
      trust: 'Trust',
      trustDesc: 'We treat your space with the utmost respect and security.',
      quality: 'Quality',
      qualityDesc: 'Uncompromising standards in every sweep and scrub.',
      care: 'Care',
      careDesc: 'Gentle on your belongings, tough on dirt.',
      detail: 'Attention to Detail',
      detailDesc: "We notice the little things so you don't have to.",
    },
  },
  testimonials: {
    title: 'What Our Clients Say',
    reviews: [
      {
        name: 'Sarah Jenkins',
        text: 'Lucy and her team are absolute lifesavers. My house has never looked so spotless. Their attention to detail is unmatched!',
      },
      {
        name: 'Michael Rodriguez',
        text: 'Professional, punctual, and thorough. We use them for our office and the difference is night and day. Highly recommend.',
      },
      {
        name: 'Emily Chen',
        text: 'I love coming home after Lucy Cleaning has been here. It smells fresh and looks perfect. The eco-friendly products are a huge plus.',
      },
    ],
  },
  contact: {
    title: 'Get in Touch',
    subtitle: "We'd love to hear from you. Request a quote or ask a question.",
    info: 'Contact Information',
    address: 'Marshfield, Massachusetts',
    phone: '+1 (781) 309-0991',
    email: 'lucycleaningservices0@gmail.com',
    hours: 'Mon-Fri: 8am - 6pm',
    form: {
      name: 'Your Name',
      phone: 'Phone Number',
      message: 'How can we help you?',
      submit: 'Send Message',
      success:
        'Thank you! Your message has been sent. We will get back to you shortly.',
    },
  },
  booking: {
    title: 'Book a Cleaning',
    subtitle: 'Schedule your next cleaning service in just a few clicks.',
    form: {
      serviceType: 'Service Type',
      selectService: 'Select a service...',
      date: 'Preferred Date',
      time: 'Preferred Time',
      name: 'Full Name',
      phone: 'Phone Number',
      address: 'Service Address',
      notes: 'Special Instructions or Notes',
      submit: 'Confirm Booking',
      successTitle: 'Booking Request Received!',
      successMsg:
        'Thank you for choosing Lucy Cleaning Services. We will contact you shortly to confirm your appointment details.',
      bookAnother: 'Book Another Service',
    },
  },
  footer: {
    tagline: 'Bringing sparkle to your space.',
    quickLinks: 'Quick Links',
    contact: 'Contact Us',
    followUs: 'Follow Us',
    rights: 'All rights reserved.',
  },
  beforeAfter: {
    title: 'Before & After',
    subtitle:
      'See the transformation. Drag the slider to reveal the difference our team makes.',
    before: 'Before',
    after: 'After',
    items: [
      { label: 'Kitchen Deep Clean' },
      { label: 'Bathroom Refresh' },
      { label: 'Living Room Reset' },
    ],
  },
}
